import Lottie from "lottie-react";
import confettiAnimation from "@/assets/animations/confetti.json";

export const ConfettiOverlay = ({ show }) => {
  if (!show) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 1000,
      pointerEvents: "none",
      overflow: "hidden"
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        transform: "scale(1.5)", 
        transformOrigin: "center center"
      }}>
        <Lottie
          animationData={confettiAnimation}
          loop={false}
          autoplay
          style={{
            width: "100%",
            height: "100%"
          }}
        />
      </div>
    </div>
  );
};
